<template>
    <div>
      <KaimonoCalc/>
    </div>
  </template>
  
  <script>
  import KaimonoCalc from '@/components/kaimono/KaimonoCalc.vue'
  
  export default {
    name: 'KaimonoTop',
    components: {
      KaimonoCalc,
    },
    setup() {
      

      return {
      }
    }
  }
  </script>
  